function fInitTabs() {
  const aTabs = document.querySelectorAll('.js-tab-toggle');

  function fRemoveActiveLink() {
    for (let i = 0; i < aTabs.length; i += 1) {
      aTabs[i].classList.remove('is-active');
    }
  }

  function fChangeActiveLink(element) {
    element.classList.add('is-active');
  }

  function fOpenTab(element) {
    const tabId = element.getAttribute('data-tab-id');
    const currentActiveTab = document.querySelector('.tabs__content.is-active');
    const target = document.getElementById(tabId);

    if (currentActiveTab) {
      currentActiveTab.classList.remove('is-active');
    }

    if (target) {
      target.classList.add('is-active');
    }

    fChangeActiveLink(element);
  }

  for (let i = 0; i < aTabs.length; i += 1) {
    aTabs[i].addEventListener('click', (event) => {
      fRemoveActiveLink();
      fOpenTab(event.target);
    });
  }

  window.addEventListener('hashchange', (event) => {
      if (window.location.hash.indexOf('#tab-') === 0) {
        event.preventDefault();
        let id = window.location.hash.split('#')[1];
        let target = document.querySelector(`[data-tab-id="${id}"]`);
        let tab = document.getElementById(id);
        let accordionTrigger = tab.querySelector('.js-accordion-open');

        fRemoveActiveLink();

        if (window.innerWidth < 768 && accordionTrigger) {
          if (!accordionTrigger.parentElement.getAttribute('data-accordion-active')) {
            accordionTrigger.click();
          }
        } else {
          fOpenTab(target);
        }

        scrollIt(target, 400, 'easeInQuad', -60);
        window.history.replaceState(null, null, ' ');
    }
  });
}
